<template>
<Teleport to="#outside">
    <div class="fixed z-[999999999] h-screen w-screen bg-black/20 flex justify-center items-center">
        <img class="w-[200px]" :src="`/images/smicos-loader.gif`" alt="">
    </div>
</Teleport>
</template>
